import tokenManager from 'client/utils/tokenManager';
import { generateApiErrObj } from 'client/hooks/useClientErrorHandler';

export const GET = 'GET';
export const PATCH = 'PATCH';
export const POST = 'POST';
export const DELETE = 'DELETE';
export const PUT = 'PUT';

export async function PromiseAll(promises = []) {
    const { errorResp } = await tokenManager.getAccessToken();
    if (errorResp) {
        throw generateApiErrObj(errorResp);
    }
    return Promise.all(promises);
}

export async function normalizeResponse(resp) {
    const rawPayload = await resp.text();
    try {
        const payload = JSON.parse(rawPayload);
        return { httpStatus: resp.status, headers: resp.headers, payload };
    } catch {
        return { httpStatus: resp.status, headers: resp.headers, rawPayload };
    }
}

export function normalizeBlobResponse(resp) {
    return resp.blob().then(blob => ({ headers: resp.headers, blob }));
}
